(ns minorodata.localforage.core
  (:require [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [applied-science.js-interop :as js-interop]
            ["localforage" :as localforage]))

(def db (js-interop/call
         localforage :createInstance
         #js {:name "Kleene"
              :version 1.0}))
